export const MESSAGES_PAGE_SIZE = 20;
export const MESSAGES_MAX_FOR_INTRO = 10; // should be <= MESSAGES_PAGE_SIZE
